import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

import { Dialog, DialogActions, DialogContent, DialogTitle, Button } from '@mui/material'

import { CreateConsultationStepEnum, CreateConsultationStepper } from './CreateConsultationStepper'

type CreateConsultationDialogProps = {
  open: boolean
  onClose: () => void
  onComplete?: () => void
  startDate?: string
  patientId?: string
}

const CreateConsultationDialog = (props: CreateConsultationDialogProps) => {
  const { open, onClose, onComplete, startDate, patientId } = props

  const { t } = useTranslation()

  const initialValues = useMemo(() => ({ patientId, startDate }), [patientId, startDate])

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>{t('dialog.createConsultation.title')}</DialogTitle>
      <DialogContent>
        <CreateConsultationStepper
          config={{ excludedSteps: [CreateConsultationStepEnum.SELECT_PATIENT] }}
          initialValues={initialValues}
          onComplete={onComplete}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          {t('common:button.back.label')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default CreateConsultationDialog
